import { Stack } from "expo-router";
import colors from '@/constants/Colors';

export default function Layout() {
    return (
        <Stack
            screenOptions={{
                headerBackButtonDisplayMode: 'minimal',
                headerStyle: {
                    backgroundColor: colors.primary,
                },
                headerTintColor: colors.accent,
            }}
        />
    )
} 